module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-binary-fill-7967e86b.svg";